module.exports = __webpack_public_path__ + "static/img/s31.8c98f375.png";